// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"eda6e9dcbcfddaa9bd0b","883":"9e40a74333e92a81c3f7"}[chunkId] + ".js";
};